'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { SocialMediaIcon } from '../ui/SocialMediaIcon';
import Image from 'next/image';
import { useParams } from 'next/navigation';
import volantBrand from '@/public/images/volant-brand.svg';
import styles from './MainFooter.module.scss';
export const MainFooter = t0 => {
  const $ = _c(20);
  const {
    navigation,
    dictionary
  } = t0;
  const {
    lang
  } = useParams();
  let t1;
  if ($[0] !== lang || $[1] !== navigation?.menu) {
    t1 = navigation?.menu?.map((item, index) => <li key={`footerNavigation-${index}`} className={styles.list}><Link href={`${lang === "fa" ? "" : `/${lang}`}/${item.link}`} className={styles.link} prefetch={false}>{item.title}</Link></li>);
    $[0] = lang;
    $[1] = navigation?.menu;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <ul className={styles.menu}>{t1}</ul>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== navigation?.social) {
    t3 = navigation?.social && Object?.entries(navigation?.social)?.map(_temp);
    $[5] = navigation?.social;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <ul className={styles.socialIcons}>{t3}</ul>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <section><nav className={styles.nav}>{t2}{t4}</nav></section>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== dictionary.meta.copyright) {
    t6 = <span className={styles.text}>{dictionary.meta.copyright}</span>;
    $[12] = dictionary.meta.copyright;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div><Image src={volantBrand} alt="volant media logo" width={105} height={34} /></div>;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6) {
    t8 = <section className={styles.copyright}>{t6}{t7}</section>;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t5 || $[18] !== t8) {
    t9 = <footer className={styles.footer}>{t5}{t8}</footer>;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default MainFooter;
function _temp(t0) {
  const [key, value] = t0;
  if (value) {
    return <li key={key}><Link href={value} target="_blank" prefetch={false}><SocialMediaIcon platform={key} width={24} height={24} /></Link></li>;
  }
}